<script setup lang="ts">
import type { CompetitorPlan } from '~~/shared/compare/types'

// One side of the "pricing compared" block: a product's plans and prices.
defineProps<{
  title: string
  plans: CompetitorPlan[]
  note?: string
  highlight?: boolean
}>()
</script>

<template>
  <div
    class="flex flex-col rounded-2xl border p-6 shadow-(--surface-shadow)"
    :class="highlight ? 'border-primary-400/40 bg-primary-500/4' : 'border-default bg-elevated/40'"
  >
    <h3 class="text-lg font-bold text-highlighted">
      {{ title }}
    </h3>
    <ul class="mt-4 flex flex-1 flex-col divide-y divide-default">
      <li
        v-for="plan in plans"
        :key="plan.name"
        class="flex flex-col gap-1 py-3 first:pt-0 last:pb-0"
      >
        <div class="flex items-baseline justify-between gap-4">
          <span class="font-medium text-toned">{{ plan.name }}</span>
          <span class="shrink-0 text-right">
            <span class="font-semibold text-highlighted">{{ plan.price }}</span>
            <span
              v-if="plan.period"
              class="ml-1 text-sm text-dimmed"
            >{{ plan.period }}</span>
          </span>
        </div>
        <p
          v-if="plan.note"
          class="text-sm text-muted"
        >
          {{ plan.note }}
        </p>
      </li>
    </ul>
    <p
      v-if="note"
      class="mt-4 text-xs text-dimmed"
    >
      {{ note }}
    </p>
  </div>
</template>
